import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { AuthProvider } from 'react-oidc-context';
import App from './App';
import { oidcConfig } from './config/auth-config';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <ErrorBoundary fallbackRender={() => <div>Unexpected error.</div>}>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </StrictMode>,
);
